import { EnvConfig } from '../config';

export const config: EnvConfig = {
  gtmId: 'GTM-N53DH7Z',
  gtmAuth: 'sB-hRX8E20w-86oOALEF1A',
  gtmPreview: 'env-1',
  splitIoAuthKey: 'gh5stqu989900vkpmc1jme4646cljmadgfbc',
};
